import React from "react";

import { NorthbeamUtmPlatform } from "@features/utm-guide";
import pinterestCatalogSales from "@features/utm-guide/images/pinterest-catalog-sales.png";
import pinterest from "@features/utm-guide/images/pinterest.png";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const Pinterest = () => (
  <div className="flex flex-col gap-3">
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <p className="font-semibold mb-0">
          For all campaigns types, except Catalog Campaigns:
        </p>
        <ul className="list-decimal pl-4 mb-0">
          <li>Navigate to the Ad level</li>
          <li>Insert the UTM parameter to the end of all Destination URLs</li>
        </ul>
      </div>
      <div className="flex flex-col gap-1">
        <p className="font-semibold mb-0">For Catalog campaigns:</p>
        <ul className="list-decimal pl-4 mb-0">
          <li>
            In the Ad Group Details, navigate to the Product Group details
          </li>
          <li>
            Under URL parameters, insert: <code>{"{lpurl}"}</code>, followed by
            the UTM parameter.
          </li>
        </ul>
      </div>
      <p className="mb-0">
        If you’re using existing parameters, you can insert our parameter at the
        end. Be sure to use an ampersand (&), instead of a question mark (?).
      </p>
    </div>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.PINTEREST} />
    <div className="flex flex-col gap-2">
      <p className="mb-0">
        If you are <b>not</b> using <b>Catalog Sales</b> as your campaign
        objective, you can set the UTMs in the location depicted by the picture
        below.
      </p>
      <img className="img-fluid mb-3" src={pinterest} alt="" />
    </div>
    <div className="flex flex-col gap-2">
      <p className="mb-0">
        If you <b>are</b> using <b>Catalog Sales</b>, you can set the UTMs in
        the location depicted by the picture below.
      </p>
      <img className="img-fluid mb-3" src={pinterestCatalogSales} alt="" />
    </div>
  </div>
);
